import { FC, useMemo } from 'react'
import styles from 'components/features/socialFeed/CommentComposeLayout/CommentComposeLayout.styl'
import { ComposeExpanded } from 'components/features/socialFeed/ComposeExpanded/ComposeExpanded'
import { ComposeId } from 'interfaces/feed'
import { compareViewports } from 'helpers/viewportHelpers'
import { MemberAvatar } from 'components/features/socialFeed/Avatar/MemberAvatar'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { currentViewportSelector } from 'selectors/viewportSelectors'

type CommentComposeLayoutProps = {
  composeId: ComposeId
}

export const CommentComposeLayout: FC<CommentComposeLayoutProps> = ({
  composeId,
  children,
}) => {
  const viewport = useStoreSelector(currentViewportSelector)
  const isMobile = useMemo(() => compareViewports(viewport, '<', 'w415'), [viewport])

  return (
    <div className={ styles.comment }>
      { isMobile && (
        <ComposeExpanded composeId={ composeId } inverse>
          <div className={ styles.avatar }>
            <MemberAvatar />
          </div>
        </ComposeExpanded>
      )}
      { !isMobile && (
        <div className={ styles.avatar }>
          <MemberAvatar />
        </div>
      )}
      <div className={ styles.inputContainer }>
        { children }
      </div>
    </div>
  )
}
